"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableChangeSentences = void 0;
var _react = _interopRequireDefault(require("react"));
var _tableChangePreview = require("../../../utils/anchor/proposal/table-change-preview");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TableChangeSentences = exports.TableChangeSentences = function TableChangeSentences(_ref) {
  var textRedline = _ref.textRedline;
  var sentences = _tableChangePreview.TableChangePreview.lines({
    edits: textRedline.tableChanges,
    anchorTextOf: function anchorTextOf(bookmark) {
      var _textRedline$paragrap, _textRedline$paragrap2;
      return (_textRedline$paragrap = (_textRedline$paragrap2 = textRedline.paragraphs.find(function (paragraph) {
        return paragraph.bookmark === bookmark;
      })) === null || _textRedline$paragrap2 === void 0 ? void 0 : _textRedline$paragrap2.textWhenProposed) !== null && _textRedline$paragrap !== void 0 ? _textRedline$paragrap : null;
    }
  });
  if (sentences.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
    className: "m-0 list-none p-0 text-[11px] leading-[16px] text-[#686766]",
    "data-sentry-component": "TableChangeSentences",
    "data-sentry-source-file": "TableChangeSentences.tsx",
    children: sentences.map(function (sentence, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        children: sentence
      }, "".concat(index, "-").concat(sentence));
    })
  });
};